function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.confirmed0{fill:#FFFFFF;}\r\n\t.confirmed1{fill:#46AA1E;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "confirmed0",
  cx: 263.5,
  cy: 263.5,
  rx: 263.5,
  ry: 263.5
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "confirmed1",
  d: "M263.2,13.5c-137,0-248,111-248,248s111,248,248,248s248-111,248-248S400.1,13.5,263.2,13.5z M263.2,61.5 c110.5,0,200,89.5,200,200s-89.5,200-200,200s-200-89.5-200-200C63.2,151,152.6,61.5,263.2,61.5 M403.4,191.8l-22.5-22.7 c-4.7-4.7-12.3-4.7-17-0.1L222.5,309.2l-59.8-60.3c-4.7-4.7-12.3-4.7-17-0.1L123,271.3c-4.7,4.7-4.7,12.3-0.1,17l90.8,91.5 c4.7,4.7,12.3,4.7,17,0.1l172.6-171.2C408,204.1,408,196.5,403.4,191.8L403.4,191.8z"
}));

const SvgIconConfirmed = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 527 527",
    style: {
      enableBackground: "new 0 0 527 527"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconConfirmed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-confirmed.98d9f1bf.svg";
export { ForwardRef as ReactComponent };